import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, message } from 'antd'
import { hasSuccessfulGseSubmission } from './utils'
import { updateInspection, resetUpdateInspection } from '../../../store/reducers/inspection/inspectionSlice'
import {
  selectInspectionsData,
  selectInspectionSubmissionsData,
  selectUpdateInspectionStatus,
  selectUpdateInspectionError,
} from '../../../store/reducers/inspection/inspectionSelectors'
import STATUS from '../../../common/constants/reducer_statuses'

const DATA_COLLECTION_COMPLETE_STATUS = 'data_collection_complete'

const CompleteDataCollectionButton = ({ refreshOrder }) => {
  const dispatch = useDispatch()

  const inspectionsData = useSelector(selectInspectionsData)
  const inspectionSubmissionsData = useSelector(selectInspectionSubmissionsData)
  const updateInspectionStatus = useSelector(selectUpdateInspectionStatus)
  const updateInspectionError = useSelector(selectUpdateInspectionError)

  const inspection = inspectionsData?.[0]
  const inspectionId = inspection?._id
  const backofficeStatus = inspection?.backoffice_status

  const hasGseSubmission = hasSuccessfulGseSubmission(inspectionSubmissionsData)
  const isAlreadyComplete = backofficeStatus === DATA_COLLECTION_COMPLETE_STATUS
  const isEnabled = hasGseSubmission && !isAlreadyComplete
  const isLoading = updateInspectionStatus === STATUS.LOADING

  useEffect(() => {
    dispatch(resetUpdateInspection())
  }, [dispatch])

  useEffect(() => {
    if (updateInspectionStatus === STATUS.SUCCEEDED) {
      message.success('Data collection completed successfully.')
      if (refreshOrder) {
        refreshOrder()
      }
    }
  }, [updateInspectionStatus, refreshOrder])

  useEffect(() => {
    if (updateInspectionStatus === STATUS.FAILED && updateInspectionError) {
      const errorMessage =
        typeof updateInspectionError === 'string'
          ? updateInspectionError
          : 'Failed to complete data collection. Please try again.'
      message.error(errorMessage)
    }
  }, [updateInspectionStatus, updateInspectionError])

  const handleCompleteDataCollection = () => {
    if (!isEnabled || isLoading || !inspectionId) {
      return
    }

    dispatch(updateInspection({
      inspectionId,
      update: { backoffice_status: DATA_COLLECTION_COMPLETE_STATUS },
      publishEvent: true,
    }))
  }

  return (
    <Button
      type="primary"
      onClick={handleCompleteDataCollection}
      disabled={!isEnabled || !inspectionId}
      loading={isLoading}
      data-testid="complete-data-collection-button"
    >
      Complete Data Collection
    </Button>
  )
}

export default CompleteDataCollectionButton
